/* global route */

import axios from 'axios';
import mapLimit from 'async/mapLimit';
import keyBy from 'lodash/keyBy';
import waitFor from '../../helpers/waitFor';

class Users {
  constructor() {
    this.users = {};
    this.allFetched = false;
    this.fetchingAll = false;
  }

  async get(id, forceFetch = false) {
    const url = route('users.show', { version: '1.0', user: id });
    let user = this.users[id];

    if (!user || forceFetch) {
      if (!this.fetchingAll) {
        const response = await axios.get(url);
        this.users[id] = response.data.data;
      } else {
        await waitFor(() => !this.fetchingAll);
      }
    }

    return this.users[id];
  }

  async getMany(ids = [], forceFetch = false) {
    return await mapLimit(ids, 5, async (id, cb) => {
      const user = await this.get(id, forceFetch);

      cb(null, user);
    });
  }

  async all(forceFetch = false) {
    let url = route('users.index', { version: '1.0', per_page: 300 });

    if (!this.allFetched || forceFetch) {
      this.fetchingAll = true;
      let nextLink = null;

      do {
        const response = await axios.get(url);

        this.indexUsers(response.data.data);

        nextLink = response.data.links.next || null;
        url = nextLink;
      } while (nextLink);

      this.allFetched = true;
      this.fetchingAll = false;
    }

    return Object.values(this.users);
  }

  indexUsers(users) {
    this.users = { ...this.users, ...keyBy(users, 'id') };

    return this.users;
  }

  async search(term, requestId, pagination) {
    if (!pagination && term === '') {
      return await this.all();
    }

    axios.cancel(requestId);

    const url = route('list-radiologists', { term, format: 'resource', ...pagination }, false);
    const result = await axios.get(url, { requestId });

    this.indexUsers(result.data);

    return [...result.data];
  }
}

export default new Users();
